import helloAndGoodbye from "./helloAndGoodbye";
import authorFromScratch from "./authorFromScratch";

const exportArray = [authorFromScratch, helloAndGoodbye];

export default exportArray;
